<template>
  <div class="container">
    <img class="banner" src="@/assets/images/gxqgouche2212/banner.jpg" alt="" />
    <div class="info-tips">
      截止目前：全区已申请<span class="blue-txt">{{ ' ' + apply_num + ' ' }}</span
      >人，燃油车已发放补贴<span class="orange-txt">{{ ' ' + oil_subsidies_money + ' ' }}</span
      >元
      <!-- 新能源汽车已发放补贴<span class="orange-txt">{{ ' ' + ne_subsidies_money + ' ' }}</span>元。 -->
    </div>
    <div class="info">
      <div class="title">高新欢乐购 枫购跨年狂欢季</div>
      <!-- <div class="tips">燃油车数币红包补贴已经申领完毕，后续购车消费者可参与购车抽奖活动。具体细则请详见下方《高新区汽车促消费活动规则》。</div> -->
      <div class="content">
        <div>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 黑体; font-size: 12pt;">特别声明</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">: </span
            ><span style="font-family: 黑体; font-size: 12pt;">请务必认真阅读本规则，一旦您在申领活动中点击同意本规则或实际申领了红包，即意味着您已阅读、充分理解和接受本规则所有条款，同意接受本规则的约束。</span>
          </p>
          <p style="line-height: 29pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 黑体; font-size: 12pt;">一、活动时间及对象</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 仿宋_GB2312; font-size: 12pt;">活动期间</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">为</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">2022</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">年</span
            ><span style="font-family: 'Times New Roman'; font-size: 12pt;">12</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">月</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">18</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">日</span
            ><span style="font-family: 'Times New Roman'; font-size: 12pt;">-202</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">年</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">月</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">18</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">日，凡在狮山商务创新区内</span
            ><span style="font-family: 'Times New Roman'; font-size: 12pt;">39</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">家汽车经销商（</span><span style="font-family: 楷体; font-size: 12pt;">详见附件一</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）购买乘用车（</span><span style="font-family: 楷体; font-size: 12pt;">仅限燃油车，不含商用车、二手车</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">），并在活动时间内完成交付、上牌的个人消费者，通过数字人民币支付购车定（</span><span style="font-family: 楷体; font-size: 12pt;">订</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）金的，将购车合同、订单票据、购车发票、行驶证、身份证和数字人民币账户及数字人民币支付购车定（</span><span style="font-family: 楷体; font-size: 12pt;">订</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）金凭证通过小程序上传后方可参与本次汽车消费活动。</span>
          </p>
          <p style="line-height: 29pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 黑体; font-size: 12pt;">二、活动内容</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 仿宋_GB2312; font-size: 12pt;">此次活动共推出</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">100</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">万元用于</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">购车补贴的发放。</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 仿宋_GB2312; font-size: 12pt;">对购买</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">10</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">万元（</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">含</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）至</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">30</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">万元以内（</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">不含保险</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）的</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">燃油</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">车辆</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">购车者</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">，给予一次性</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">000</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">元数字人民币红包补贴；</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 仿宋_GB2312; font-size: 12pt;">对购买</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">30</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">万元（</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">含</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）及</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">以上</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">（</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">不含保险</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">的燃油</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">车辆</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">购车者</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">，给予一次性</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">5</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">000</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">元数字人民币红包补贴</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">；</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 仿宋_GB2312; font-size: 12pt;">数字人民币红包补贴数额有限，按照先到先得的原则，每人限领一次，领完即止（</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">先到先得</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">,</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">按申请材料通过时间为准，具体活动</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">规则见</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">附件二</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">）</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">。</span>
          </p>
          <p style="margin: 0pt; orphans: 0; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 16pt; font-weight: bold;">&#xa0;</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <br style="page-break-before: always; clear: both;" />
          </p>
          <p style="margin: 0pt; orphans: 0; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">附件一：</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;"><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">限上零售业汽车经销商名单</span><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">（不含新能源）</span></p>
          <div style="text-align: center; overflow: scroll;">
            <table cellspacing="0" cellpadding="0" style="border-collapse: collapse; margin: 0 auto; width: 354.1pt;">
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 仿宋_GB2312; font-size: 10.5pt; font-weight: bold;">序号</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 仿宋_GB2312; font-size: 10.5pt; font-weight: bold;">企业名称</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">1</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州海星高新汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">2</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州元通汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">3</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市汽车工业贸易有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">4</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">元诺汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">5</span>
                  </p>
                </td>
                <td
                  style="
                    background-color: #ffffff;
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市文珺汽车销售有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">6</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">浚</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">和汽车销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">7</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州宝华汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">8</span>
                  </p>
                </td>
                <td style="border-left-color: #000000; border-left-style: solid; border-left-width: 0.75pt; border-right-color: #000000; border-right-style: solid; border-right-width: 0.75pt; padding-left: 5.03pt; padding-right: 5.03pt; vertical-align: middle; width: 271.9pt;">
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州海盛汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">9</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市都市飞越汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">10</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州和</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">奥汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">11</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州禾胜汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">12</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州宝铁龙</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">之星汽车有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">13</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州丰丰汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">14</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州亚奥汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;"><span style="font-family: 'Times New Roman'; font-size: 10.5pt;">1</span><span style="font-family: 'Times New Roman'; font-size: 10.5pt;">5</span></p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">颉</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">田汽车销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">16</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市金</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">阊众翔汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">17</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州小康汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">18</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州中</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">升沃茂汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">19</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市金</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">阊众辉汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">20</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州华意汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">21</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州众和汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">22</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州华飞汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;"><span style="font-family: 'Times New Roman'; font-size: 10.5pt;">2</span><span style="font-family: 'Times New Roman'; font-size: 10.5pt;">3</span></p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州建通汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">24</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市都市飞梭汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">25</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州由</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">由</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">丰田汽车销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">26</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州天驰新田</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">汽车销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">27</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">天驰新佳汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">28</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州华达汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">29</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州久久汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">30</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州广达汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">31</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">建孚汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">32</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州正田汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">33</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州建通凯迪汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">34</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州领之星汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">35</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州运通和</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">远汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">36</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州运通和</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">捷汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">37</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;"><span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州益</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">谦汽车</span><span style="font-family: 仿宋_GB2312; font-size: 11pt;">销售服务有限公司</span></p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">38</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州市国懋汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: top;
                    width: 59.85pt;
                  "
                >
                  <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
                    <span style="font-family: 'Times New Roman'; font-size: 10.5pt;">39</span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom-color: #000000;
                    border-bottom-style: solid;
                    border-bottom-width: 0.75pt;
                    border-left-color: #000000;
                    border-left-style: solid;
                    border-left-width: 0.75pt;
                    border-right-color: #000000;
                    border-right-style: solid;
                    border-right-width: 0.75pt;
                    border-top-color: #000000;
                    border-top-style: solid;
                    border-top-width: 0.75pt;
                    padding-left: 5.03pt;
                    padding-right: 5.03pt;
                    vertical-align: middle;
                    width: 271.9pt;
                  "
                >
                  <p style="margin: 0pt;">
                    <span style="font-family: 仿宋_GB2312; font-size: 11pt;">苏州苏新汽车销售服务有限公司</span>
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <p style="line-height: 29pt; margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 仿宋_GB2312; font-size: 12pt; font-weight: bold;">附件二：</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0;">
            <span style="font-family: 宋体; font-size: 12pt; font-weight: bold;">购车补贴活动规则</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">一、补贴活动要求：</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span><span style="font-family: 仿宋; font-size: 12pt;">、</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车辆</span><span style="font-family: 仿宋; font-size: 12pt;">购车者指</span
            ><span style="font-family: 仿宋; font-size: 12pt;">在参与活动的汽车经销商（详见附件一）购买新</span><span style="font-family: 仿宋; font-size: 12pt;">燃油</span><span style="font-family: 仿宋; font-size: 12pt;">车的个人消费者</span
            ><span style="font-family: 仿宋; font-size: 12pt;">；</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span><span style="font-family: 仿宋; font-size: 12pt;">、支付定（订）金时间、合同签订时间及上牌时间均</span><span style="font-family: 仿宋; font-size: 12pt;">在活动时间内</span
            ><span style="font-family: 仿宋; font-size: 12pt;">；</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span><span style="font-family: 仿宋; font-size: 12pt;">、已开通数字人民币钱包，且购车定（订）金必须</span><span style="font-family: 仿宋; font-size: 12pt;">使用数字人民币支付；</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">4</span><span style="font-family: 仿宋; font-size: 12pt;">、由</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者作为红包申请人，</span
            ><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者与合同签订人、机动车销售发票</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">“</span><span style="font-family: 仿宋; font-size: 12pt;">购买方</span
            ><span style="font-family: 'Times New Roman'; font-size: 12pt;">”</span><span style="font-family: 仿宋; font-size: 12pt;">、行驶证登记车主及数字人民币银行账户所有人必须为</span><span style="font-family: 仿宋; font-size: 12pt;">同一自然人；</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">5</span><span style="font-family: 仿宋; font-size: 12pt;">、</span><span style="font-family: 仿宋; font-size: 12pt;">同一个申请人参与此活动仅可享受一辆新购燃油汽车补贴，同一辆车不重复享受辖区内同类购车节活动优惠。</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">二、申请流程：</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt;">在活动规定时间内（</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">2022</span><span style="font-family: 仿宋; font-size: 12pt;">年</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">12</span
            ><span style="font-family: 仿宋; font-size: 12pt;">月</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">18</span><span style="font-family: 仿宋; font-size: 12pt;">日</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">0</span
            ><span style="font-family: 仿宋; font-size: 12pt;">时至</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">202</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span><span style="font-family: 仿宋; font-size: 12pt;">年</span
            ><span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span><span style="font-family: 仿宋; font-size: 12pt;">月</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">18</span><span style="font-family: 仿宋; font-size: 12pt;">日</span
            ><span style="font-family: 'Times New Roman'; font-size: 12pt;">24</span><span style="font-family: 仿宋; font-size: 12pt;">时），</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者本人通</span
            ><span style="font-family: 仿宋; font-size: 12pt;">过在</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">“</span><span style="font-family: 仿宋; font-size: 12pt;">狮山商务创新区</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">”</span
            ><span style="font-family: 仿宋; font-size: 12pt;">微信公众号</span><span style="font-family: 仿宋; font-size: 12pt;">平台上</span><span style="font-family: 仿宋; font-size: 12pt;">“</span><span style="font-family: 仿宋; font-size: 12pt;">跨年狂欢季</span
            ><span style="font-family: 仿宋; font-size: 12pt;"> </span><span style="font-family: 仿宋; font-size: 12pt;">枫购“油”你！</span><span style="font-family: 仿宋; font-size: 12pt;">”</span><span style="font-family: 仿宋; font-size: 12pt;">活动页面提交相关信息进行报名申领。</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">三、需提交申请资料：</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span><span style="font-family: 仿宋; font-size: 12pt;">、有效身份证件和联系电话；</span></p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span><span style="font-family: 仿宋; font-size: 12pt;">、新购车辆购车合同（网上订车的可提供截图）及定（订）金票据；</span></p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span><span style="font-family: 仿宋; font-size: 12pt;">、通过数字人民币支付购车定（订）金的凭证；</span></p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">4</span><span style="font-family: 仿宋; font-size: 12pt;">、新购</span><span style="font-family: 仿宋; font-size: 12pt;">燃油</span><span style="font-family: 仿宋; font-size: 12pt;">车辆的机动车销售统一发票、购车金额；</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">5</span><span style="font-family: 仿宋; font-size: 12pt;">、新购</span><span style="font-family: 仿宋; font-size: 12pt;">燃油</span><span style="font-family: 仿宋; font-size: 12pt;">车辆的行驶证、经销商信息；</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 'Times New Roman'; font-size: 12pt;">6</span><span style="font-family: 仿宋; font-size: 12pt;">、数字人民币银行账户、开立机构。</span></p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">*</span><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">注意事项：</span><span style="font-family: 仿宋; font-size: 12pt;">为保障</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span
            ><span style="font-family: 仿宋; font-size: 12pt;">购车者能用数字人民币支付购车定（订）金，</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者需</span
            ><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">本人</span><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">开通数字人民币钱包</span><span style="font-family: 仿宋; font-size: 12pt;">，且开通数字人民币红包的手机号码须与申领补贴</span
            ><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">手机号码一致</span><span style="font-family: 仿宋; font-size: 12pt;">。</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">四、审核程序：</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt;">由狮山</span><span style="font-family: 仿宋; font-size: 12pt;">商务创新区组织工作人员对</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者申请材料进行审核，</span
            ><span style="font-family: 仿宋; font-size: 12pt;">额度用完后停止接收审核申请，活动结束后于工作日统一对</span><span style="font-family: 仿宋; font-size: 12pt;">通过审核的</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span
            ><span style="font-family: 仿宋; font-size: 12pt;">购车者</span><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">名单进行公示</span><span style="font-family: 仿宋; font-size: 12pt;">，</span
            ><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">公示时间为</span><span style="font-family: 'Times New Roman'; font-size: 12pt; font-weight: bold;">5</span><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">个工作日</span
            ><span style="font-family: 仿宋; font-size: 12pt;">，名单将在</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">“</span><span style="font-family: 仿宋; font-size: 12pt;">狮山商务创新区</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">”</span
            ><span style="font-family: 仿宋; font-size: 12pt;">微信公众号</span><span style="font-family: 仿宋; font-size: 12pt;">平台上公示；公示无异议的，</span><span style="font-family: 'Times New Roman'; font-size: 12pt; font-weight: bold;">5</span
            ><span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">个工作日内</span><span style="font-family: 仿宋; font-size: 12pt;">发放数字人民币购车红包到申请人数字人民币钱包。咨询电话：0512-68256493/66652480</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 仿宋; font-size: 12pt; font-weight: bold;">五、红包使用规则：</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span><span style="font-family: 仿宋; font-size: 12pt;">、红包的使用有效期为：自领取数字人民币红包之日起</span><span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span
            ><span style="font-family: 仿宋; font-size: 12pt;">个月内。此次发放的红包可在苏州大市范围内已完成数字人民币系统改造的商户使用，不可提现，不可转给他人。</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span><span style="font-family: 仿宋; font-size: 12pt;">、超过有效期未使用的红包将自动返还</span><span style="font-family: 仿宋; font-size: 12pt;">至</span><span style="font-family: 仿宋; font-size: 12pt;">相应</span
            ><span style="font-family: 仿宋; font-size: 12pt;">运营机构，</span><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者将不再享有权利。若发生退款交易，系统将优先退还通过审核的</span
            ><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者自行充</span><span style="font-family: 仿宋; font-size: 12pt;">值支付</span><span style="font-family: 仿宋; font-size: 12pt;">的数字人民币金额，再退还</span
            ><span style="font-family: 仿宋; font-size: 12pt;">购车节</span><span style="font-family: 仿宋; font-size: 12pt;">促消费</span><span style="font-family: 仿宋; font-size: 12pt;">活动数字人民币红包金额。在有效期外发生的退款，红包将暂时退至通过审核的</span
            ><span style="font-family: 仿宋; font-size: 12pt;">燃油车</span><span style="font-family: 仿宋; font-size: 12pt;">购车者个人数字钱包，再由系统回收。</span>
          </p>
          <p style="line-height: 29pt; margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
            <span style="font-family: 仿宋_GB2312; font-size: 12pt; font-weight: bold;">六、活动声明</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">、参与活动所留姓名、购车发票、行驶证、保单、身份证和个人银行卡号，</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">将作为本次活动领取奖品的唯一凭证，若填写错误导致未能领取获奖权益，失权责任由参与者承担。</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">、特别声明或约定：所有获奖机会不得转让，因参与者提交信息有误而导致未能领取获奖权益，失权责任由参与者承担。</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">、本次活动不得伪造购车记录，一经发现将被取消活动参与资格，并将向公安机关和相应行政执法部门处置报告相关信息，涉及违法犯罪的将依法追究法律责任。</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">4</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">、参与活动的手机号必须为实名登记的手机号，否则将取消获奖资格。</span>
          </p>
          <p style="line-height: 20pt; margin: 0pt; orphans: 0; text-align: justify; text-indent: 21pt; widows: 0;">
            <span style="font-family: 'Times New Roman'; font-size: 12pt;">5</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">、本活动最终解释权</span><span style="font-family: 仿宋_GB2312; font-size: 12pt;">归活动</span
            ><span style="font-family: 仿宋_GB2312; font-size: 12pt;">主办方所有。</span>
          </p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="tips">
        <div class="btn-img">
          <img v-if="!checked" @click="checked = !checked" src="@/assets/images/gxqgouche2212/dischecked.png" />
          <img v-if="checked" @click="checked = !checked" src="@/assets/images/gxqgouche2212/checked.png" />
        </div>
        <p>我已阅读并同意<span class="blue-txt">《高新区汽车促销费活动规则》</span></p>
      </div>
      <div class="btn">
        <div class="add-btn" @click="handleAdd">立即申请</div>
        <!-- <div class="record-btn" @click="handleRecord">记录</div>
        <div class="add-btn" @click="handleAdd">新增</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getStat } from '@/service/gxqgouche2212/index'
export default {
  name: 'Home',
  data() {
    return {
      checked: false,
      apply_num: '',
      total_subsidies_money: '',
      oil_subsidies_money: '',
      ne_subsidies_money: ''
    }
  },
  mounted() {
    this.toast = this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: '加载中'
    })
    // 获取人数
    getStat()
      .then((res) => {
        this.apply_num = res.data.apply_num
        this.total_subsidies_money = res.data.total_subsidies_money
        this.oil_subsidies_money = res.data.oil_subsidies_money
        this.ne_subsidies_money = res.data.ne_subsidies_money
        this.toast.clear()
      })
      .catch(() => {
        this.toast.clear()
      })
    // this.$dialog.alert({
    //   messageAlign: 'left',
    //   confirmButtonColor: '#131177',
    //   message:
    //     '<p class="dialog-title" style="font-weight: bold;text-align: center;">关于“汽车钜惠·驭价而归”数字人民币消费红包购车抽奖活动信息录入真实性的声明</p><p style="color: #888888;">\n&emsp;&emsp;消费者在参与活动的经销商处购车后提供相关个人信息，由经销商负责填写相关报名参与信息，经销商应对录入信息的真实性负有法律责任，一经发现有弄虚作假行为的，将被取消活动参与及中奖资格，并将向公安机关和相关行政执法部门报告相关信息，涉及违法犯罪的依法追究法律责任。</p>'
    // })
  },
  methods: {
    handleAdd() {
      if (this.checked) {
        //   isInhand().then((res) => {
        //     if (res.data.state == 0) {
        //       this.$toast('活动未开始')
        //     } else if (res.data.state == 2) {
        //       this.$toast('活动已结束')
        //     } else {
        this.$router.push('/add-car')
        //     }
        //   })
      } else {
        this.$toast('请先阅读并同意《高新区汽车促销费活动规则》')
      }
    },
    handleRecord() {
      // if (this.checked) {
      this.$router.push('/record-list')
      // } else {
      //   this.$toast('请先阅读并同意红包预约申领及发放规则')
      // }
    }
  }
}
</script>
<style lang="stylus" scoped>
.container
  height 100%
  overflow-y scroll
  .banner
    width 100%
    height auto
  .info-tips
    font-size: 24px;
    margin-top: 30px
    margin-left: 20px
    margin-right: 20px
  .info
    padding 30px 30px
    .tips
      color: red;
      font-size: 24px;
      margin-top: -20px;
      margin-bottom: 10px;
    .title,.subtitle
      text-align center
      position relative
    .title
      font-size: 35px;
      font-weight bold
      color rgb(26, 145, 255)
      margin-bottom 50px
    .title::after
      content: ''
      position: absolute
      width: 160px;
      height: 10px;
      opacity: 0.3;
      background: rgb(178,184,244)
      top: 55px
      left: 0;
      right: 0;
      margin: auto;
    .subtitle
      font-size 30px
      color #1A1A1A
      font-weight bold
      margin-bottom 43px
    .content
      padding 35px
      height calc(100vh - 720px)
      overflow-y scroll
      background: #FFFFFF;
      box-shadow: 0px 0px 15px 0px rgba(176, 200, 220, 0.4);
      border-radius: 10px;
      font-size 28px
  .footer
    position fixed
    bottom 0
    padding 0 50px
    .btn
      display flex
      font-size: 32px;
      .record-btn,.add-btn
        color #ffffff
        text-align center
        line-height 90px
        font-weight bold
        border: 1px solid #D8D8D8;
        border-radius: 10px;
        margin-bottom 25px
      .record-btn
        margin-right 22px
        width: 335px;
        height: 90px;
        background: #0557DE;
      .add-btn
        margin-top: 20px;
        width: 670px;
        height: 90px;
        background: rgb(19,28,225);
    .tips
      font-size 26px
      display flex
      align-items: center
      .btn-img
        width: 39px;
        height: 39px;
        flex-shrink: 0
        margin-right 18px
  .red-txt
    color red
  .blue-txt
    color rgb(26, 145, 255)
  .orange-txt
    color #F15418
</style>
